import React from 'react';
import { bool, func, string } from 'prop-types';

// Utils
import { format, isValid, parseISO, subDays } from 'date-fns';
import { useGetAffiliateOptions } from 'hooks';

// Components
import { Box, Button, Drawer, IconButton, Typography } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { MDropdown } from 'common';
import CloseRounded from '@mui/icons-material/CloseRounded';

const LegendDrawer = props => {
  const {
    bolDate,
    mobileFilterDrawerOpen,
    selectedAffiliate,
    setBolDate,
    setMobileFilterDrawerOpen,
    setSelectedAffiliate,
  } = props;

  const affiliates = useGetAffiliateOptions(['supplier']);
  const affiliateOptions = [{ label: 'All', value: 'all' }, ...affiliates];

  const handleDateChange = date => {
    if (isValid(date)) {
      setBolDate(format(date, 'yyyy-MM-dd'));
    }
  };

  const handleClear = () => {
    setSelectedAffiliate('all');
    setBolDate(format(subDays(new Date(), 1), 'yyyy-MM-dd'));
  };

  const showClear =
    selectedAffiliate !== 'all' || bolDate !== format(subDays(new Date(), 1), 'yyyy-MM-dd');

  return (
    <Drawer
      anchor="right"
      open={mobileFilterDrawerOpen}
      slotProps={{
        paper: {
          sx: {
            backgroundColor: 'surface.light',
            top: 0,
            width: '85%',
          },
        },
      }}
    >
      <Box
        sx={{
          alignItems: 'center',
          borderBottom: ({ palette }) => `1px solid ${palette.graphic.light}`,
          display: 'flex',
          justifyContent: 'space-between',
          pb: 0.5,
          pt: 1.5,
          px: 2,
        }}
      >
        <Typography variant="h5">Filter</Typography>
        <IconButton
          onClick={() => setMobileFilterDrawerOpen(false)}
          size="large"
          sx={{ color: 'secondary.medium' }}
        >
          <CloseRounded />
        </IconButton>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          padding: '26px 18px 18px',
        }}
      >
        {affiliates.length > 1 && (
          <MDropdown
            anchorOrigin={{
              horizontal: 'center',
              vertical: 'top',
            }}
            id="affiliate-select"
            items={affiliateOptions}
            label="Affiliate"
            name="affiliate"
            onChange={({ value }) => setSelectedAffiliate(value)}
            value={selectedAffiliate}
          />
        )}
        <DatePicker
          label="Date"
          maxDate={subDays(new Date(), 1)}
          minDate={subDays(new Date(), 90)}
          onChange={handleDateChange}
          sx={{ width: '100%' }}
          value={parseISO(bolDate)}
        />
        {showClear && (
          <Button
            onClick={handleClear}
            sx={{
              mb: 0,
              mt: 2.5,
              mx: 'auto',
            }}
            variant="text"
          >
            Clear
          </Button>
        )}
      </Box>
    </Drawer>
  );
};

LegendDrawer.propTypes = {
  bolDate: string.isRequired,
  mobileFilterDrawerOpen: bool.isRequired,
  selectedAffiliate: string.isRequired,
  setBolDate: func.isRequired,
  setMobileFilterDrawerOpen: func.isRequired,
  setSelectedAffiliate: func.isRequired,
};

export default LegendDrawer;
